'use client';

import { Suspense } from 'react';

import { useReferral } from '@/hooks/use-referral';

function ReferralTrackerContent() {
  // Используем хук для отслеживания рефералов
  useReferral();

  // Этот компонент не рендерит ничего, только отслеживает рефералы
  return null;
}

export default function ReferralTracker() {
  return (
    <Suspense fallback={null}>
      <ReferralTrackerContent />
    </Suspense>
  );
}
